/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react'
import { useComponentHeight } from '@btime/react-hooks'
import React from 'react'

import breakpoints from '../../utils/constants/breakpoints'

export const Relative = ({ top, bottom, left, right, minHeight, ...props }) => {
  const style = css`
    position: relative;
    top: ${top};
    bottom: ${bottom};
    left: ${left};
    right: ${right};
    min-height: ${minHeight};
  `
  return <div css={style} {...props} />
}

export const Space = ({ children, height }) => {
  return (
    <div className="space" style={{ height }}>
      {children}
    </div>
  )
}
export const Absolute = ({
  scroll,
  top,
  bottom,
  bottomOnSm,
  left,
  right,
  bgColor,
  zIndex,
  useSpace,
  translate,
  ...props
}) => {
  const style = css`
    position: absolute;
    top: ${top};
    bottom: ${bottom};
    left: ${left};
    right: ${right};
    background-color: ${bgColor};
    z-index: ${zIndex};
    ${translate ? `transform: translate(${translate})` : ''};
    ${scroll ? `overflow-y: scroll;` : ''};

    @media (max-width: ${breakpoints.sm}px) {
      bottom: ${bottomOnSm};
    }
  `

  const contentRef = React.useRef(null)
  const height = useComponentHeight(useSpace && contentRef)

  return (
    <Space height={useSpace && height}>
      <div ref={contentRef} className="absolute" css={style} {...props} />
    </Space>
  )
}

export const Fixed = ({ top, bottom, bottomOnSm, left, right, zIndex, useSpace, ...props }) => {
  const style = css`
    position: fixed;
    top: ${top};
    bottom: ${bottom};
    left: ${left};
    right: ${right};
    z-index: ${zIndex};

    @media (max-width: ${breakpoints.sm}px) {
      bottom: ${bottomOnSm};
    }
  `

  const contentRef = React.useRef(null)
  const height = useComponentHeight(useSpace && contentRef)

  return (
    <Space height={useSpace && height}>
      <div ref={contentRef} className="fixed" css={style} {...props} />
    </Space>
  )
}
